
import Vue from 'vue';
import { mapState } from 'vuex';
import ListItem from '@/components/base/ListItem.vue';
import PurpleChip2 from '@/components/base/PurpleChip2.vue';
import {
	ReferralUserInfo,
	DAILY_FREE_RUNNIT_TOKENS_PER_REFERRAL,
	DAILY_FREE_RUNNIT_TOKENS_BASE,
} from '@run-diffusion/shared';
import { MyBalanceMixin } from '@/mixins';

export default Vue.extend({
	name: 'ReferralTable',
	mixins: [
		MyBalanceMixin,
	],
	components: {
		PurpleChip2,
		ListItem,
	},
	data () {
		return {
			DAILY_FREE_RUNNIT_TOKENS_PER_REFERRAL,
			DAILY_FREE_RUNNIT_TOKENS_BASE,
		};
	},
	computed: {
		...mapState([
			'user',
		]),

		accountSetupFinished(): boolean {
			return !!this.userBalanceAccountRunnitTokensData.isFreemiumPassportValid;
		},

		hasAcceptedReferral(): boolean {
			return !!this.user?.freemiumInfo?.acceptedReferralCode;
		},

		hasReferrals(): boolean {
			return this.formattedReferrals.length > 0;
		},

		hasReferralsOrAccepted(): boolean {
			return this.hasReferrals || this.hasAcceptedReferral;
		},

		hasReferralsOrAcceptedOrAccountSetupFinished(): boolean {
			return this.hasReferralsOrAccepted || this.accountSetupFinished;
		},

		referralUserInfos(): Record<string, ReferralUserInfo> {
			return this.user?.freemiumInfo?.referralUserInfos || {};
		},

		formattedReferrals(): ReferralUserInfo[] {
			const referrals: ReferralUserInfo[] = Object.values(this.referralUserInfos);
			// Sort by date (newest first)
			return referrals.sort((a: ReferralUserInfo, b: ReferralUserInfo) =>
				b.createdAt.toMillis() - a.createdAt.toMillis()
			);
		},
	},
});
